import { TreeNode } from "primeng/api";
import { environment } from "../../../../../environments/environment";
import { SectionService } from "../../../service/section-service/section-service";
import { Art57Section } from "../../Art57Section/Art57Section";
import { DynamicListView } from "../../Data/DynamicListView";
import { PaginationControl } from "../../PaginationControl";
import { Util } from "../../Util";
import { Art57NodeUtils } from "../Art57Node/Art57NodeUtils";
import { BaseNode } from "../BaseNode";
import { ResultList } from "../ListEntity/ResultList";
import { QueryFieldsNode } from "../QueryFieldsNode";
import { QueryNode } from "../QueryNode";
import { Injector } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { ServiceEnum } from "../../ServiceEnum";
import { MeddraQueryResultNode } from "./MeddraQueryResultNode";
import { MeddraService } from "../../../service/meddra-service/meddra.service";
import { DateUtil } from "../../DateUtil";
import { QueryConditionsNode } from "../QueryConditionsNode";

export class MeddraQueryNode extends QueryNode {

    constructor(injector: Injector, data: any, labelTemplate: string, entityName: string, fields: FormlyFieldConfig[], conditions: FormlyFieldConfig[], entityNode: BaseNode | null) {
        super(injector, data, labelTemplate, fields, conditions, entityName, ServiceEnum.Meddra, entityNode);
    }

    override processResult(pageToRetrieve: PaginationControl, nodeRequest: BaseNode, data: any): void {
        let resultNodeList: TreeNode | null = Art57NodeUtils.findFirstChildNodeOfType(this, ResultList);
        let resultNode = null;
        if (resultNodeList) {
            if ((!(nodeRequest instanceof ResultList)) && (!(nodeRequest instanceof MeddraQueryResultNode))) {
                // This is the RUN scenario
                if (data && (data.length > 0)) {
                    const fieldsNode: QueryFieldsNode = (Art57NodeUtils.findFirstChildNodeOfType(this, QueryFieldsNode) as QueryFieldsNode);
                    const conditionsNode: QueryConditionsNode = (Art57NodeUtils.findFirstChildNodeOfType(this, QueryConditionsNode) as QueryConditionsNode);
                    const listViewInstance = new DynamicListView(data, fieldsNode.getFieldsToShow());
                    resultNode = new MeddraQueryResultNode(this.ioc!, listViewInstance, "Result " + DateUtil.getResultDateTime(), this.entityName, fieldsNode.getFieldsToRetrieve(), fieldsNode, conditionsNode);
                    resultNode.paginationControl = pageToRetrieve;
                    resultNode.parent = resultNodeList;
                    resultNodeList.children?.push(resultNode);
                    this.ioc!.get(SectionService).selectMeddraNode(resultNode);
                }

            } else {
                //This is the RERUN scenario
                nodeRequest.data.model = data;
                resultNode = nodeRequest;
                this.ioc!.get(SectionService).selectMeddraNode(resultNode);
            }
            
        }
    }

    getRecordsToExcel(pageToRetrieve: PaginationControl | null, isExport: boolean) {
        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Exporting records to Excel file...', life: environment.successElapsedTime });

        if (pageToRetrieve == null) {
            pageToRetrieve = new PaginationControl();
            pageToRetrieve.setFields(this.getFields());
            pageToRetrieve.setCriteria(this.getConditions());
        }

        this.ioc!.get(MeddraService).filterToExcel(this.entityName, pageToRetrieve.criteria, pageToRetrieve.currentPage, false, isExport, pageToRetrieve.fields)
            .subscribe((response: any) => {
                const contentDisposition = response.headers.get('content-disposition');
                const filename = contentDisposition.match(/filename=(.+)$/)[1].replace(/['"]/, '').trim();
                const url = window.URL.createObjectURL(response.body as Blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Exporting records to Excel finished', life: environment.successElapsedTime });
            }, (error: any) => {
                this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                throw error;
            });
    }

    executeQueryToExcel() {
        this.getRecordsToExcel(null, false);
    }

    exportToExcel() {
        this.getRecordsToExcel(null, true);
    }
    getDate(): string {
        const date = new Date();

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hour = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${year}-${month}-${day}+${hour}.${minutes}.${seconds}`;
    }


}